document.addEventListener("DOMContentLoaded", function () {
  // $('.grid-slick').slick({
  //   speed: 30000, // Even slower transition
  //   autoplay: true,
  //   autoplaySpeed: 0,
  //   centerMode: true,
  //   cssEase: 'linear',
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: true,
  //   initialSlide: 1,
  //   arrows: false,
  //   buttons: false
  // });
    $('.bestsellers-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 2 }
        }
      ]
    });
  });


window.addEventListener('load', function () {
    const loader = document.querySelector('.loader, .loading, .preloader, #loader');
    if (loader) loader.style.display = 'none';
});

  document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector("form[action='/contact']");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault(); // Prevent real submission (only for JS-based display)
        form.style.display = "none";

        const message = document.createElement("div");
        message.className = "success-message";
        message.innerHTML = `
          <h2>Vielen Dank für Ihre Nachricht!</h2>
          <p>Wir haben Ihre Anfrage erhalten und melden uns so schnell wie möglich.</p>
        `;

        const container = document.querySelector(".no-results-message");
        container.appendChild(message);

        // Keep the message visible for 15 seconds, then fade it out
        setTimeout(() => {
          message.style.transition = "opacity 1s ease-out";
          message.style.opacity = "0";
          setTimeout(() => message.remove(), 1000); // Remove from DOM after fade out
        }, 15000); // 15 seconds
      });
    }
  });






     
  





